/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback, useContext, useEffect, useState } from 'react';
import RestartAlt from '@mui/icons-material/RestartAlt';
import Tooltip from '@mui/material/Tooltip';
import { Input } from 'antd';
import { formatCustomDate } from '../../helpers/formatCustomDate';
import GeneralCustomTable from '../../helpers/GeneralCustomTable';
import { useForm } from 'react-hook-form';
import LogicContext from '../../Context/LogicContext';
import { toLowercaseKeys } from '../../helpers/toLowerCaseKeys';
import PermissionModuleFilter from './PermissionModuleFilter';
import { permissionProfileService } from '../../services/permissionProfile.service';
import { SetPermissionProfileAtom , GetPermissionProfileAtom} from '../../store/permissionProfileAtom';

const { Search } = Input;

function PermissionProfileMainPage() {
  const { pathname } = useLocation();
  const logicContext = useContext(LogicContext);
  const navigate = useNavigate();
  const  setProfileAtom = SetPermissionProfileAtom();
  const  getProfileAtom = GetPermissionProfileAtom();

  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const [filteredData, setFilteredData] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);

  const {
    handleSubmit,
    formState: { errors },
  } = useForm();




  useEffect(() => {
    document.title = 'Permission profile';
    if(!getProfileAtom.module.length || !getProfileAtom.profile.length){
      loadTableList();
    }
  }, []);



  useEffect(() => {
    if (sessionStorage.getItem('reloadPage') === 'true') {
      sessionStorage.removeItem('reloadPage');
      reloadData();
    }
  }, []);



  const reloadData = useCallback(() => {
    loadTableList();
  }, []);



  const loadTableList = useCallback(() => {
    permissionProfileService.profileList().then((res) => {
      const serverData = toLowercaseKeys(res.data);

      if (serverData) {
        setProfileAtom(serverData);
      }
    });
  }, []);



  useEffect(() => {
    if (Array.isArray(getProfileAtom.module) && getProfileAtom.module.length > 0) {
      const allModule = getProfileAtom.module.find((m) => m.module_id === 0);
      setSelectedModule(allModule || null);
    }
  }, [getProfileAtom.module]);



  useEffect(() => {
    if (!Array.isArray(getProfileAtom.profile)) return;

    if (!selectedModule || selectedModule.module_id === 0) {
      setFilteredData(getProfileAtom.profile);
      return;
    }

    const filtered = getProfileAtom.profile.filter(
      (item) => item.module_id === selectedModule.module_id
    );

    setFilteredData(filtered);
  }, [getProfileAtom.profile, selectedModule]);



  const addNew = useCallback(() => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }, [navigate, currModuleId, currModuleName, currUserMenu]);



  const handleRowClick = useCallback(
    (record) => {
      navigate(
        `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${record?.profile_id}`
      );
    },
    [navigate, currModuleId, currModuleName, currUserMenu]
  );



  const onModuleSelect = (module) => {
    setSelectedModule(module);
  };

  const columns = [
    {
      title: 'Profile ID',
      dataIndex: 'profile_id',
      sorter: (a, b) => (a?.profile_id ?? 0) - (b?.profile_id ?? 0),
    },
    {
      title: 'Profile Name',
      dataIndex: 'profile_name',
      className: 'text-primary',
      sorter: (a, b) =>
        (a?.profile_name ?? '').localeCompare(b?.profile_name ?? ''),
    },
    {
      title: 'Module Name',
      dataIndex: 'module_name',
      sorter: (a, b) =>
        (a?.module_name ?? '').localeCompare(b?.module_name ?? ''),
    },
    {
      title: 'Status',
      dataIndex: 'profile_status_name',
      sorter: (a, b) =>
        (a?.profile_status_name ?? '').localeCompare(
          b?.profile_status_name ?? ''
        ),
    },
    {
      title: 'Date',
      dataIndex: 'encoded_date',
      sorter: (a, b) => (a?.encoded_date ?? 0) - (b?.encoded_date ?? 0),
      render: (record) => <span>{formatCustomDate(record)}</span>,
    },
  ];

  return (
    <>
      <section className="mt-8 px-6">
        <div className="flex items-center justify-between mb-4 bg-gray-50 rounded-lg shadow-sm p-4">
          <Tooltip title="Reload">
            <RestartAlt
              className="cursor-pointer text-blue-600 hover:text-blue-800 h-10 w-10 p-1"
              onClick={reloadData}
            />
          </Tooltip>

          <div className='text-xl font-bold text-gray-800' >
             Menu Assingn to Profile
          </div>

          <button
            onClick={addNew}
            className="h-10 px-4 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            ADD NEW
          </button>
        </div>

        <div className="flex items-center gap-4">
          <PermissionModuleFilter
            moduleMenuList={getProfileAtom.module}
            onModuleSelect={onModuleSelect}
            defaultVal={0} 
          />
        </div>
      </section>

      <section className="mt-5 w-full">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={filteredData}
          allowCheckBox={true}
          rowKey={(record) => record.ref_no}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
}

export default PermissionProfileMainPage;
